import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["properties"];
import styled from 'styled-components';
import { LayoutGrid } from 'breeze-intelligence-kit';
import { MatchRateProperty } from './MatchRateProperty';
import { jsx as _jsx } from "react/jsx-runtime";
const GridContainer = styled(LayoutGrid).withConfig({
  displayName: "MatchRatePropertiesGrid__GridContainer",
  componentId: "sc-2sp64o-0"
})(["--grid-border:var(--layout-lib-border-light);& > *:not(:nth-last-child(-n + 2):nth-child(2n + 1)):not(:last-child){border-block-end:var(--grid-border);}& > *:not(:nth-child(2n)){border-inline-end:var(--grid-border);}"]);
export const MatchRatePropertiesGrid = _ref => {
  let {
      properties = []
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (properties.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(GridContainer, Object.assign({}, rest, {
    alignItems: "stretch",
    borderBlock: "border-light",
    gap: "0",
    gridTemplateColumns: "1fr 1fr",
    children: properties.map(property => /*#__PURE__*/_jsx(MatchRateProperty, {
      name: property.label,
      paddingBlock: "space",
      paddingInline: "space-xl",
      value: property.percent
    }, property.name))
  }));
};